# GraphQL fragment to enable/disable Google calendar sync

#import "../fragments/calendar-sync.graphql"

mutation setGoogleCalendarSyncIsEnabled($isEnabled: Boolean!, $forceReauth: Boolean) {
    setGoogleCalendarSyncIsEnabled(
        input: {calendarSync: {isEnabled: $isEnabled, forceReauth: $forceReauth}}
    ) {
        authUrl
        calendarSync {
            ...CalendarSync
        }
    }
}
